import { Storage } from "@ionic/storage";

export const store = new Storage();
export const setupStorage = async () => {
  await store.create();
  store.set("app_version", "1.0.0");
};
